import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountService } from '../../../../../../../services/account/account.service';
import { TaxRateService } from '../../../../../../../services/tax-rate/tax-rate.service';
import { TaxRate } from '../../../../../../../models/tax-rate';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';

@Component({
  selector: 'app-add-tax-rate-modal',
  templateUrl: './add-tax-rate-modal.component.html',
  styleUrls: ['./add-tax-rate-modal.component.css']
})
export class AddTaxRateModalComponent implements OnInit {

  @Input() savedCallback: (result: CallbackResult) => undefined;

  public taxRate: TaxRate = {
    id: null,
    url: null,
    name: '',
    rate_percent: null,
    created_at: null,
    updated_at: null
  };

  public loadingSubmit = false;
  public errors: any = {};
  public errorMessage = '';

  public serverError: number = null;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    public taxRateService: TaxRateService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().is_organization_admin) {
      return;
    }
  }

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';
    this.errors = {};

    this.taxRateService
      .addTaxRate(this.taxRate)
      .then(createdTaxRate => {
        this.savedCallback({
          text: this.taxRate.name + ' created successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errors = reason.error;
          this.errorMessage = 'Please correct the errors above and try again.';
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to create tax rates.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
